if (!customElements.get('attrbt-ambient-video')) {
  customElements.define(
    'attrbt-ambient-video',
    class AttrbtAmbientVideo extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('video');
        if (!video) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.pause();
          return;
        }

        const attempt = video.play();
        if (attempt) attempt.catch(() => {});
      }
    }
  );
}
